import React from 'react';

import './Attribution.css';

/*** Component ***/
const Attribution = () => {
  return (
    <div className="item attribution">
      <a className="item" href="http://loading.io" target="blank">
        the spinner "Ellipsis" is provided by loading.io
      </a>
    </div>
  );
};

export default Attribution;
